import React from 'react';
import { themeObject } from 'lib';
// eslint-disable-next-line import/no-extraneous-dependencies
import { orbit } from 'ldrs';

orbit.register();

export const CardLoader = (): React.JSX.Element => {
    return (
        <l-orbit
            size='35'
            speed='1.5'
            color={themeObject.palette.primary[300]}
        />
    );
};
